import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { useRealPathname } from '@ui/hooks/router';
import usePersistentContext from '@ui/hooks/usePersistentContext';
import { languages, useLanguage } from '@ui/i18n';
import { useRouter } from '@ui/overrides/next/router';

export const LangMenu = () => {
  const router = useRouter();
  const language = useLanguage();
  const realPathname = useRealPathname();
  const [_, setDefaultLanguage] = usePersistentContext('selectedLanguage');

  return (
    <Menu placement="bottom">
      <MenuButton as={Button} variant="raised">
        {language.name}
      </MenuButton>
      <MenuList>
        {languages.map((langItem, i) => {
          return (
            <MenuItem
              key={i}
              onClick={() => {
                router.push(realPathname, undefined, {
                  locale: langItem.lang,
                });
                setDefaultLanguage(langItem.lang);
              }}
            >
              {langItem.name}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
